import React from "react";
import { Helmet } from "react-helmet";
import { capitalize, isOdd, replaceSpecialCharsets } from "../../../scripts/commons/common";
import { newTileLinkCreator } from "../../../services/newTileLinkCreator";
import { numberWithSpaces } from "../../common/number-with-spaces";

const joinParts = (parts, separator) => parts.filter((part) => part !== null && part !== undefined && String(part).trim() !== "").join(separator);

/**
 * Title for new / afterlease car page:
 * {Marka} {Model} {Wersja}, {rok}, {przebieg - tylko poleasingowe} | mAuto.pl
 * Uwaga: cena auta (netto) NIE moze byc pokazywana dla nowych samochodow (wymog biznesowy).
 */
const buildCarTitle = (details, pageType) => {
  const name = joinParts([details.Make, details.Model, replaceSpecialCharsets(details.Type)], " ");
  const mileage = Number(details.Mileage);
  const differentiator = pageType === "afterLease" && mileage > 0 ? `${numberWithSpaces(mileage)} km` : null;

  return `${joinParts([name, details.Year, differentiator], ", ")} | mAuto.pl`;
};

/**
 * Meta description for new / afterlease car page:
 * {Marka} {Model} {rok}, {przebieg} km, {paliwo}. Rata od {rata} zł netto. {2 elementy wyposażenia}. Sprawdź online w mAuto!
 */
const buildCarDescription = (details, pageType, installment) => {
  const mileage = Number(details.Mileage);
  const fuel = details.IsElectric
    ? "elektryczny"
    : (details.FuelTypeFullName || details.FuelType || "").toLowerCase();
  const firstSentence = joinParts(
    [
      joinParts([details.Make, details.Model, details.Year], " "),
      pageType === "afterLease" && mileage > 0 ? `${numberWithSpaces(mileage)} km` : null,
      fuel
    ],
    ", "
  );
  const equipmentSource =
    details.Equipment && details.Equipment.length ? details.Equipment : details.EquipmentStandard || [];
  const equipment = joinParts(equipmentSource.slice(0, 2).map((item) => replaceSpecialCharsets(item)), ", ");
  const installmentValue = Number(installment);

  return joinParts(
    [
      `${firstSentence}.`,
      installmentValue > 0 ? `Rata od ${numberWithSpaces(Math.round(installmentValue))} zł netto.` : null,
      equipment ? `${equipment}.` : null,
      "Sprawdź online w mAuto!"
    ],
    " "
  );
};

const DetailsPageHelmet = (props) => {
  const segment =
    props.pageType === "new"
      ? "nowe-samochody"
      : props.pageType === "afterLease"
        ? "samochody-poleasingowe"
        : "aukcje-samochodowe";
  const pathname = `/${segment}/${newTileLinkCreator(props.details.Make, props.details.Model, props.details.AuctionId)}`;
  const canonicalHref =
    typeof window !== "undefined" && window.location && window.location.origin
      ? `${window.location.origin}${pathname}`
      : pathname;
  const isCarOffer = props.pageType === "new" || props.pageType === "afterLease";

  return (
    <Helmet>
      {isCarOffer && <title>{buildCarTitle(props.details, props.pageType)}</title>}
      {isCarOffer && (
        <meta name="description" content={buildCarDescription(props.details, props.pageType, props.installment)} />
      )}

      <link rel="canonical" href={canonicalHref} />

      {props.pageType === "auction" && isOdd(props.paramId) && (
        <meta
          name="description"
          content={`Znajdź swój wymarzony samochód z mAuto. Sprawdź nasze aukcje pojazdów. Może znajdziesz tu ${props.details.Make} ${props.details.Model}, na który czekasz? `}
        />
      )}
      {props.pageType === "auction" && !isOdd(props.paramId) && (
        <meta
          name="description"
          content={`Szukasz ${props.details.Make} ${props.details.Model} w atrakcyjnej cenie? Weź udział w aukcjach mAuto i daj sobie szansę na zakup idealnego auta!`}
        />
      )}
      {props.pageType === "auction" && (
        <title>
          {capitalize(props.details.Make)} {props.details.Model} {replaceSpecialCharsets(props.details.Type)} - aukcja
          samochodu | mAuto.pl
        </title>
      )}
    </Helmet>
  );
};
export default DetailsPageHelmet;
